import api from "./axios";

const API_URL = "/auth";

export const registerUser = (user) => api.post(`${API_URL}/register`, user);
export const loginUser = (credentials) => api.post(`${API_URL}/login`, credentials);

// Get current user info
export const getCurrentUser = () => api.get(`${API_URL}/me`);

// Credential switching
export const getUserCredentials = () => api.get(`${API_URL}/credentials`);
export const switchCredential = (credentialId) => api.post(`${API_URL}/switch-credential/${credentialId}`);

// OIDC/Keycloak
export const getOIDCConfig = () => api.get(`${API_URL}/oidc/config`);
export const handleOIDCCallback = (code, redirectUri, codeVerifier) => 
  api.post(`${API_URL}/oidc/callback`, { 
    code, 
    redirect_uri: redirectUri,
    code_verifier: codeVerifier 
  });
